export const SiteHtmlPageTitle = "Cellular, Wi-Fi, LoRa & Satellite IoT | Blues";
export const ShortSiteHtmlPageTitle = "IoT Connectivity at Blues";
